module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('z-input', {
    attrs: {
      "name": "logDescription",
      "id": "logDescription",
      "label": "Текст события",
      "disabled": ""
    },
    model: {
      value: (_vm.log.description),
      callback: function($$v) {
        _vm.$set(_vm.log, "description", $$v)
      },
      expression: "log.description"
    }
  }), _vm._v(" "), _c('z-input', {
    attrs: {
      "name": "logEntity",
      "id": "logEntity",
      "label": "Наличие сущности",
      "value": (_vm.log.entity) ? 'Существует' : 'Удалена',
      "disabled": ""
    }
  }), _vm._v(" "), _c('z-input', {
    attrs: {
      "name": "createdAt",
      "id": "createdAt",
      "label": "Дата события",
      "disabled": ""
    },
    model: {
      value: (_vm.log.created_at),
      callback: function($$v) {
        _vm.$set(_vm.log, "created_at", $$v)
      },
      expression: "log.created_at"
    }
  }), _vm._v(" "), _c('z-input', {
    attrs: {
      "name": "logType",
      "id": "logType",
      "label": "Тип события",
      "value": (_vm.log.log_type === 'user') ? 'Пользовательское' : 'Системное',
      "disabled": ""
    }
  }), _vm._v(" "), _c('z-input', {
    attrs: {
      "name": "logAction",
      "id": "logAction",
      "label": "Код события",
      "disabled": ""
    },
    model: {
      value: (_vm.log.log_action),
      callback: function($$v) {
        _vm.$set(_vm.log, "log_action", $$v)
      },
      expression: "log.log_action"
    }
  }), _vm._v(" "), (_vm.log.user) ? _c('z-input', {
    attrs: {
      "name": "userLogin",
      "id": "userLogin",
      "label": "Пользователь",
      "disabled": ""
    },
    model: {
      value: (_vm.log.user.login),
      callback: function($$v) {
        _vm.$set(_vm.log.user, "login", $$v)
      },
      expression: "log.user.login"
    }
  }) : _vm._e(), _vm._v(" "), _c('z-input', {
    attrs: {
      "name": "logModule",
      "id": "logModule",
      "label": "Модуль",
      "disabled": ""
    },
    model: {
      value: (_vm.log.module.code),
      callback: function($$v) {
        _vm.$set(_vm.log.module, "code", $$v)
      },
      expression: "log.module.code"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50da191c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/logs/views/Log.vue
// module id = 1134
// module chunks = 0